import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/my-styles/(pages)/(detail)')({
  component: DetailLayout,
});

function DetailLayout() {
  // Shared chrome for /my-styles/(styles|variants|skus)/$id pages.
  // Currently a passthrough — add back button / breadcrumb here later.
  return <Outlet />;
}
